import { Mountain, Footprints, Flame, Signpost, Tent, Map, ArrowUpRight } from "lucide-react";
import { ACTIVITIES } from "@/data/content";

const ICONS = { Mountain, Footprints, Flame, Signpost, Tent, Map };

export const Activities = () => {
  return (
    <section
      id="services"
      data-testid="activities-section"
      className="relative bg-[var(--navy)] py-20 overflow-hidden"
    >
      {/* Decorative dots / blobs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#fcd34d]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-[#e11d2e]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-4 lg:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 text-[var(--yellow)] font-semibold text-[11px] tracking-[0.3em] mb-3">
            <span className="h-px w-10 bg-[#fcd34d]/60" />
            TRAVEL BY ACTIVITY
            <span className="h-px w-10 bg-[#fcd34d]/60" />
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-white leading-tight">
            Adventure &{" "}
            <span className="text-[var(--yellow)]">Activity</span>
          </h2>
          <p className="text-white/65 mt-4 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            From snowy summits to red-dust deserts — choose how you want to feel
            on holiday. Six curated activity collections, hundreds of departures,
            one travel company that knows the difference.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {ACTIVITIES.map((a, i) => {
            const Icon = ICONS[a.icon] || Mountain;
            return (
              <a
                href="#destinations"
                key={a.title}
                data-testid={`activity-${i}`}
                className="group relative bg-white/[0.04] hover:bg-white/[0.07] backdrop-blur border border-white/10 hover:border-[#fcd34d]/60 rounded-xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1"
              >
                {/* Yellow corner accent */}
                <span className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight className="w-4 h-4 text-[var(--yellow)]" />
                </span>

                <div className="relative mb-4">
                  <div className="absolute inset-0 bg-[#fcd34d]/20 rounded-full blur-xl scale-75 group-hover:scale-100 transition-transform duration-500" />
                  <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-[var(--yellow)] to-[var(--yellow-2)] flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-[#fcd34d]/20">
                    <Icon className="w-7 h-7 text-[var(--navy)]" strokeWidth={1.75} />
                  </div>
                </div>

                <div className="font-serif-display text-lg text-white group-hover:text-[var(--yellow)] transition-colors">
                  {a.title}
                </div>
                <div className="text-[11px] uppercase tracking-wider text-white/50 mt-1">
                  {a.count}
                </div>

                {/* Bottom accent line */}
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 group-hover:w-2/3 h-[2px] bg-[var(--yellow)] transition-all duration-500" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
